import { Auth0Provider } from "@auth0/auth0-react";
import * as React from "react";
import { useEffect, useState } from "react";
import { AUTH0_SCOPE } from "../../constants/env";

const Auth0Wrapper = ({ children }: { children: React.ReactNode }) => {
  const [redirectUri, setRedirectUri] = useState("");

  useEffect(() => {
    setRedirectUri(window.location.origin + "/dashboard?authType=auth0");
  }, []);

  if (!process.env.NEXT_PUBLIC_AUTH0_DOMAIN) {
    throw Error("NEXT_PUBLIC_AUTH0_DOMAIN is not set");
  }
  if (!process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID) {
    throw Error("NEXT_PUBLIC_AUTH0_CLIENT_ID is not set");
  }
  if (!process.env.NEXT_PUBLIC_AUTH0_PAPERCUP_SERVICES_AUDIENCE) {
    throw Error("NEXT_PUBLIC_AUTH0_PAPERCUP_SERVICES_AUDIENCE is not set");
  }
  return (
    <Auth0Provider
      domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN}
      clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}
      redirectUri={redirectUri}
      // Binder services API (supports Allow Offline Access) - keeping this as
      // the default means login obtains a token for the audience ProfileProvider
      // later requests silently, so the silent call is a cache hit and no
      // iframe fallback is needed. The Management API audience cannot be used
      // here: it is an Auth0 system API with no offline_access support, which
      // forces the iframe path and breaks in incognito (3rd-party cookies).
      audience={process.env.NEXT_PUBLIC_AUTH0_PAPERCUP_SERVICES_AUDIENCE}
      // [security-test] Temporarily switched from "localstorage" to "memory" to
      // evaluate app behaviour without tokens persisted in localStorage.
      // Trade-off: on page reload/new tab the in-memory cache is empty, so the
      // SDK falls back to iframe silent auth (getTokenSilently), which can fail
      // in Safari/Incognito due to third-party-cookie restrictions.
      cacheLocation={"memory"}
      scope={AUTH0_SCOPE}
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0Wrapper;
